/* RESPONSIBLE TEAM: team-proactive-support */
import type Node from './node';
import type Edge from './edge';
import type Offset from './offset';

interface GraphHooksInterface {
  canInsertNode?(dataObject: any): boolean;
  didInsertNode?(node: Node): void;

  canUpdateNode?(node: Node, offset: Offset): boolean;
  didUpdateNode?(node: Node): void;

  canDeleteNode?(node: Node): boolean;
  didDeleteNode?(node: Node): void;

  canSelectNode?(node: Node): boolean;

  canSelectEdge?(edge: Edge): boolean;

  canInsertEdge?(predecessor: Node, successor: Node): boolean;
  didInsertEdge?(edge: Edge): void;

  canDeleteEdge?(edge: Edge): boolean;
  didDeleteEdge?(edge: Edge): void;

  canAddNodesToSelection?(event?: Event): boolean;

  undeleteNode?<T>(serializedNode: any): T | undefined;
  undeleteEdge?<T>(serializedEdge: any): T | undefined;
}

export { GraphHooksInterface };

export default class Hooks {
  externalHooks?: GraphHooksInterface;

  constructor(externalHooks?: GraphHooksInterface) {
    this.externalHooks = externalHooks;
  }

  canInsertNode(dataObject: any): boolean {
    if (this.externalHooks?.canInsertNode) {
      return this.externalHooks.canInsertNode(dataObject);
    } else {
      return true;
    }
  }

  didInsertNode(node: Node): void {
    if (this.externalHooks?.didInsertNode) {
      return this.externalHooks.didInsertNode(node);
    }
  }

  canUpdateNode(node: Node, offset: Offset): boolean {
    if (this.externalHooks?.canUpdateNode) {
      return this.externalHooks.canUpdateNode(node, offset);
    } else {
      return true;
    }
  }

  didUpdateNode(node: Node): void {
    if (this.externalHooks?.didUpdateNode) {
      this.externalHooks.didUpdateNode(node);
    }
  }

  canDeleteNode(node: Node): boolean {
    if (this.externalHooks?.canDeleteNode) {
      return this.externalHooks.canDeleteNode(node);
    } else {
      return true;
    }
  }

  didDeleteNode(node: Node): void {
    if (this.externalHooks?.didDeleteNode) {
      this.externalHooks.didDeleteNode(node);
    }
  }

  canSelectNode(node: Node): boolean {
    if (this.externalHooks?.canSelectNode) {
      return this.externalHooks.canSelectNode(node);
    } else {
      return true;
    }
  }

  canSelectEdge(edge: Edge): boolean {
    if (this.externalHooks?.canSelectEdge) {
      return this.externalHooks.canSelectEdge(edge);
    } else {
      return true;
    }
  }

  canInsertEdge(predecessor: Node, successor: Node): boolean {
    if (this.externalHooks?.canInsertEdge) {
      return this.externalHooks.canInsertEdge(predecessor, successor);
    } else {
      return true;
    }
  }

  didInsertEdge(edge: Edge): void {
    if (this.externalHooks?.didInsertEdge) {
      return this.externalHooks.didInsertEdge(edge);
    }
  }

  canDeleteEdge(edge: Edge): boolean {
    if (this.externalHooks?.canDeleteEdge) {
      return this.externalHooks.canDeleteEdge(edge);
    } else {
      return true;
    }
  }

  didDeleteEdge(edge: Edge): void {
    if (this.externalHooks?.didDeleteEdge) {
      return this.externalHooks.didDeleteEdge(edge);
    }
  }

  canAddNodesToSelection(event?: Event): boolean {
    if (this.externalHooks?.canAddNodesToSelection) {
      return this.externalHooks.canAddNodesToSelection(event);
    } else {
      return false;
    }
  }

  undeleteNode<T>(serializedNode: any): T | undefined {
    if (this.externalHooks?.undeleteNode) {
      return this.externalHooks.undeleteNode<T>(serializedNode);
    }

    return;
  }

  undeleteEdge<T>(serializedEdge: any): T | undefined {
    if (this.externalHooks?.undeleteEdge) {
      return this.externalHooks.undeleteEdge(serializedEdge);
    }

    return;
  }
}
